module.exports = "https://cdn.realtymogul.com/static/media/RP_Lodgeatmain.0b671420.jpg";